/* istanbul ignore file */
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Route } from 'react-router-dom';
import { ProjectRouter } from './project';
import NewProjectRouter from './newProject/newProjectRouter';
import BillingRouter from './newProject/finance/billing/BillingRouter';
import ProjectsComplianceRouter from './projectsCompliance/ProjectsComplianceRouter';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';

const ProjectsRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { isFeatureEnabled } = useFeatureToggle();

  return [
    <Route path={ProjectRouter.getRouterPath()} element={<ProjectRouter />} />,
    <Route path={NewProjectRouter.getRouterPath()} element={<NewProjectRouter />} />,
    <Route path={BillingRouter.getRouterPath()} element={<BillingRouter />} />,
    isFeatureEnabled(Features.PROJECTS_COMPLIANCE) && (
      <Route path={ProjectsComplianceRouter.getRouterPath()} element={<ProjectsComplianceRouter />} />
    ),
    <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />,
  ];
};

export default ProjectsRouter;
